export default {
  // 登录页
  '主播开播管理': 'Quản lý phát sóng BLV',
  '请输入手机号': 'Vui lòng nhập số điện thoại',
  '请输入手机验证码': 'Vui lòng nhập mã xác minh SMS',
  '请输入图形验证码': 'Mã xác minh',
  '登录': 'Đăng nhập',
  '登录成功': 'Đăng nhập thành công',
  '登录失败': 'Đăng nhập thất bại',

  // 侧边栏菜单
  '直播设置': 'Cài đặt live',
  '节目管理': 'Q lý chương trình',
  '房间管理': 'Quản lý phòng',
  '禁言设置': 'C đặt cấm chat',
  '我的收益': 'T nhập của tôi',
  '我的粉丝团': 'Fanclub của tôi',
  '抽奖': 'Quay thưởng',
  '趣猜': 'Dự đoán vui',

  // 直播设置页
  '直播间标题': 'Tiêu đề phòng livestream',
  '房间ID': 'ID phòng',
  '直播间封面': 'Ảnh bìa livestream',
  '未设置': 'Chưa thiết lập',
  '直播间公告': 'Thông báo phòng livestream',
  '直播窗口公告': 'Thông báo cửa sổ livestream',
  '分钟轮播一次': 'Phát lại mỗi X phút',
  '去编辑': 'Đi chỉnh sửa',
  '去直播': 'Bắt đầu livestream',
  '点击修改': 'Nhấn để chỉnh sửa',
  '上传封面': 'Tải ảnh bìa lên',
  '建议图片尺寸为： 750像素*426像素。支持jpg、png图片': 'Khuyến nghị kích thước ảnh: 750px * 426px. Hỗ trợ ảnh jpg, png',
  '选择公告展示区域': 'Chọn khu vực hiển thị thông báo',
  '暂无数据': 'Chưa có dữ liệu',
  '请输入您的直播间公告内容': 'Vui lòng nhập nội dung thông báo phòng livestream',
  '备注：手机端遵循以上设置展示，电脑端始终在主播页面展示': 'Ghi chú: Điện thoại sẽ hiển thị theo cài đặt trên, máy tính luôn hiển thị trên trang streamer',
  '公告区域': 'Khu vực thông báo',
  '全部展示（个人主页和直播视频下方）': 'Hiển thị tất cả (trang cá nhân và bên dưới video livestream)',
  '仅在个人主页展示公告': 'Chỉ hiển thị trên trang cá nhân',
  '选择公告轮播频率': 'Chọn tần suất phát thông báo',
  '可输入引导加入粉丝群、推荐爆料等信息': 'Có thể nhập nội dung như: mời tham gia nhóm fan, giới thiệu tin hot, v.v.',
  '备注：设定后直播窗口会以固定的频率播放此公告内容': 'Ghi chú: Sau khi thiết lập, cửa sổ livestream sẽ phát nội dung này theo tần suất cố định',
  '保存': 'Lưu',
  '返回': 'Quay lại',
  '您的直播间已被禁用，请联系客服!': 'Phòng livestream của bạn đã bị vô hiệu hóa, vui lòng liên hệ CSKH!',
  '图片格式：仅支持png、jpg': 'Định dạng ảnh: chỉ hỗ trợ png, jpg',
  '确认': 'Xác nhận',
  '请输入直播间标题': 'Vui lòng nhập tiêu đề livestream',
  '保存成功': 'Lưu thành công',

  // 5 分钟轮播选项
  '分钟轮播一次': 'Phát lại mỗi X phút',

  // 赛程页面
  '热门比赛': 'Trận đấu hot',
  '今日': 'Hôm nay',
  '场比赛': 'X trận đấu',
  '收起': 'Thu gọn',
  '展开': 'Mở rộng',
  '今天': 'Hôm nay',
  '比赛中': 'Đang thi đấu',
  '加时': 'Hiệp phụ',
  '点球': 'Đá luân lưu',
  '比赛推迟': 'Trận bị hoãn',
  '未开始': 'Chưa bắt đầu',
  '已结束': 'Đã kết thúc',
  '进行中': 'Đang diễn ra',
  '已添加': 'Đã thêm',
  '添加计划': 'Thêm kế hoạch',
  '暂无即将开始的比赛！': 'Chưa có trận nào sắp diễn ra!',
  '您确定要取消本场直播计划吗？': 'Bạn có chắc muốn hủy kế hoạch livestream trận này không?',
  '赛事名称': 'Tên giải đấu',
  '主客队': 'Đội chủ/đội khách',
  '比赛时间': 'Thời gian thi đấu',
  '直播时间': 'Thời gian livestream',
  '取消直播': 'Hủy livestream',
  '设置直播时间': 'Thiết lập thời gian livestream',
  '已取消计划': 'Đã hủy kế hoạch',
  '已加入直播计划': 'Đã thêm vào kế hoạch livestream',
  '网络连接失败，请检查您的网络！': 'Kết nối mạng thất bại, vui lòng kiểm tra lại mạng!',
  '全部': 'Tất cả',
  '赛程': 'Lịch thi đấu',
  '积分榜': 'Bảng xếp hạng',
  '射手榜': 'Vua phá lưới',
  '助攻榜': 'Bảng kiến tạo',
  '排行榜': 'Bảng xếp hạng',
  '球队榜': 'Bảng đội bóng',
  '球员榜': 'Bảng cầu thủ',
  '开始日期': 'Ngày bắt đầu',
  '结束日期': 'Ngày kết thúc',

  // 房管设置页
  '房管设置': 'Cài đặt quản lý phòng (mod)',
  '添加房管': 'Thêm quản lý phòng',
  '所属平台': 'Nền tảng',
  '用户昵称': 'Tên người dùng',
  '任命时间': 'Thời gian bổ nhiệm',
  '操作': 'Thao tác',
  '撤销': 'Thu hồi',
  '您确定要撤销此房管？': 'Bạn có chắc muốn thu hồi quyền quản lý này không?',
  '请选择所属平台': 'Vui lòng chọn nền tảng',
  '请输入昵称': 'Vui lòng nhập nickname',
  '请选择平台': 'Vui lòng chọn nền tảng',
  '自己不可以被添加为房管': 'Không thể thêm chính mình làm quản lý phòng',
  '已撤销': 'Đã thu hồi',
  '已添加': 'Đã thêm',
  '添加房管': 'Thêm quản lý phòng',
  '撤销房管': 'Thu hồi quản lý',

  // 节目管理页
  '直播节目': 'Chương trình live',
  '历史记录': 'Lịch sử',
  '新增直播': 'Thêm live mới',
  '新增直播节目': 'Thêm c trình live mới',
  '请选择直播赛事': 'Vui lòng chọn trận đấu để live',
  '请选择赛事': 'Vui lòng chọn giải đấu',
  '请选择比赛时间': 'Vui lòng chọn thời gian thi đấu',
  '查询': 'Tìm kiếm',
  '类型': 'Loại',
  '直播计划时间': 'Thời gian k hoạch live',
  '赛事': 'Giải đấu',
  '主客队/节目名称': 'Đội chủ/đội khách / Tên chương trình',
  '正在直播': 'Đang livestream',
  '开始直播': 'Bắt đầu live',
  '结束直播': 'Kết thúc live',
  '修改': 'Chỉnh sửa',
  '取消': 'Hủy',
  '正在为你生成直播流地址，建议您配置好OBS后开始直播': 'Đang tạo địa chỉ luồng live cho bạn, khuyến nghị cấu hình OBS xong rồi hãy bắt đầu livestream',
  '建议您先设置OBS停止推流后结束直播，如果您已设置请忽略': 'Khuyến nghị bạn thiết lập OBS dừng stream trước khi kết thúc live, nếu đã thiết lập thì bỏ qua',
  '填写节目名称': 'Nhập tên chương trình',
  '修改直播时间': 'Chỉnh sửa thời gian live',
  '直播间名称': 'Tên phòng live',
  '直播内容': 'Nội dung live',
  '比赛流地址': 'Địa chỉ luồng trận đấu',
  '暂无比赛流地址，请稍后再试': 'Chưa có địa chỉ luồng trận đấu, vui lòng thử lại sau',
  '刷新': 'Làm mới',
  '复制': 'Sao chép',
  '服务器': 'Máy chủ',
  '串流密钥': 'Khóa stream (Stream key)',
  '未获取到比赛流地址，请稍后再试': 'Chưa lấy được địa chỉ luồng trận đấu, vui lòng thử lại sau',
  '已复制': 'Đã sao chép',

  // 趣猜页面
  '趣猜': 'Dự đoán vui',
  '趣猜列表': 'Danh sách dự đoán vui',
  '历史记录': 'Lịch sử',
  '玩法介绍': 'Giới thiệu cách chơi',
  '发起趣猜': 'Tạo dự đoán',
  '趣猜主题': 'Chủ đề',
  '趣猜选项': 'Các lựa chọn',
  '投注人数': 'Số người cược',
  '投注金额': 'Số tiền đặt cược',
  '赔率': 'Tỷ lệ cược',
  '结账时间': 'Thời gian kết toán',
  '趣猜结果': 'Kết quả',
  '主播佣金': 'Hoa hồng BLV',
  '出题时间': 'Thời gian tạo',
  '状态': 'Trạng thái',
  '操作': 'Thao tác',
  '已停止': 'Đã dừng',
  '结账': 'Kết toán',
  '选择胜利方选项': 'Chọn phương án thắng',
  '流局（以上都不是）': 'Hòa (không phương án nào đúng)',
  '确定': 'Xác nhận',
  '返回': 'Quay lại',
  '趣猜结账': 'Kết toán dự đoán',
  '请输入趣猜题目': 'Vui lòng nhập câu hỏi dự đoán',
  '选项一': 'Lựa chọn 1',
  '请输入趣猜选项': 'Vui lòng nhập lựa chọn',
  '选项二': 'Lựa chọn 2',
  '持续时间': 'Thời gian duy trì',
  '选择趣猜投注时间范围': 'Chọn khoảng thời gian đặt cược',
  '确认发起': 'Xác nhận tạo',
  '网络连接失败，请检查您的网络！': 'Kết nối mạng thất bại, vui lòng kiểm tra lại mạng!',
  '请输入趣猜主题': 'Vui lòng nhập chủ đề dự đoán',
  '已成功发起趣猜': 'Đã tạo dự đoán thành công',
  '流局': 'Hòa',
  '趣猜玩法介绍': 'Giới thiệu cách chơi dự đoán',
  '已绑定手机': 'Đã liên kết số điện thoại',
  '您可以享受手机相关的安全服务': 'Bạn có thể sử dụng các dịch vụ bảo mật liên quan đến điện thoại',
  '新昵称': 'Nickname mới',
  '请输入新的昵称': 'Vui lòng nhập nickname mới',
  '昵称最多10个字符，30天内只能修改一次': 'Nickname tối đa {number} ký tự, chỉ được đổi 1 lần trong 30 ngày',
  '基本资料': 'Thông tin cơ bản',
  '修改昵称': 'Đổi nickname',
  '修改昵称成功': 'Đổi nickname thành công',
  '备注': 'Ghi chú',

  // 收益页面
  '金币收益': 'Thu nhập xu',
  '钻石收益': 'Thu nhập kim cương',
  '收益类型': 'Loại thu nhập',
  '详情': 'Chi tiết',
  '完成时间': 'Thời gian hoàn thành',
  '金币记录': 'Lịch sử xu',
  '钻石记录': 'Lịch sử kim cương',
  '请选择时间': 'Vui lòng chọn thời gian',

  // 粉丝页面
  '您还没开通粉丝团？': 'Bạn chưa mở fanclub?',
  '立即申请': 'Đăng ký ngay',
  '您提交的申请正在审核中，请耐心等待！': 'Đơn đăng ký của bạn đang được xét duyệt, vui lòng chờ!',
  '抱歉！您的申请已被驳回，请联系客服！': 'Xin lỗi! Đơn đăng ký của bạn đã bị từ chối, vui lòng liên hệ CSKH!',
  '申请粉丝团': 'Đăng ký fanclub',
  '修改徽章名称': 'Sửa tên huy hiệu',
  '徽章名称': 'Tên huy hiệu',
  '请输入粉丝徽章名称': 'Vui lòng nhập tên huy hiệu fan',
  '确认申请': 'Xác nhận đăng ký',
  '确认修改': 'Xác nhận chỉnh sửa',
  '全部直播平台': 'Tất cả nền tảng livestream',
  '团成员': 'Thành viên nhóm',
  '本周新成员': 'Thành viên mới tuần này',
  '本周亲密度': 'Độ thân mật tuần này',
  '粉丝徽章名称': 'Tên huy hiệu người hâm mộ',

  // 禁言设置页
  '禁言设置': 'Cài đặt cấm chat',
  '请输入用户昵称': 'Vui lòng nhập nickname người dùng',
  '请选择禁言时间': 'Vui lòng chọn thời gian cấm chat',
  '禁言时间': 'Thời gian cấm chat',
  '用户头像': 'Ảnh đại diện người dùng',
  '解禁时间': 'Thời gian bỏ cấm',
  '解除禁言': 'Bỏ cấm chat',
  '确定要取消禁言？': 'Bạn có chắc muốn bỏ cấm không?',
  '已取消禁言': 'Đã bỏ cấm',
  '取消禁言': 'Hủy cấm chat',

  // 抽奖页面
  '抽奖记录': 'Lịch sử quay thưởng',
  '抽奖规则': 'Quy tắc quay thưởng',
  '中奖名单': 'D sách trúng thưởng',
  '开启抽奖': 'Bắt đầu quay thưởng',
  '抽奖类型': 'Loại quay thưởng',
  '奖品份数': 'S lượng phần thưởng',
  '抽取规则': 'Quy tắc chọn',
  '面向用户': 'Đ tượng người dùng',
  '开启时间': 'Thời gian bắt đầu',
  '弹幕抽奖': 'Quay thưởng bằng bình luận (chat)',
  '送礼抽奖': 'Quay thưởng bằng tặng quà',
  '人数': 'Số người',
  '人次': 'Số lượt',
  '全部用户': 'Tất cả người dùng',
  '关注用户': 'Người đã theo dõi',
  '粉丝团用户': 'Thành viên fanclub',
  '等级用户': 'Người dùng theo cấp độ',
  '未知用户': 'Người dùng chưa xác định',
  '用户等级': 'Cấp độ người dùng',
  '级': 'Cấp',
  '金币': 'Xu',
  '兑换券': 'Phiếu đổi thưởng',
  '请输入每份奖品金币数量': 'Vui lòng nhập số xu cho mỗi phần thưởng',
  '请选择兑换卷奖品': 'Vui lòng chọn phần thưởng bằng phiếu',
  '请输入奖品份数': 'Vui lòng nhập số lượng phần thưởng',
  '如主播666': 'Ví dụ: streamer 666',
  '请输入送礼数量': 'Vui lòng nhập số lượng quà tặng',
  '本月抽奖专用剩余金币': 'Số xu quay thưởng còn lại trong tháng',
  '本月抽奖专用剩余兑换券': 'Số phiếu đổi thưởng còn lại trong tháng',
  '级': 'Cấp',
  '已成功开启抽奖': 'Đã bắt đầu quay thưởng thành công',
  '不能同时开启多个抽奖活动': 'Không thể mở nhiều chương trình quay thưởng cùng lúc',
  '请输入抽奖金额': 'Vui lòng nhập số tiền quay thưởng',
  '请输入指定弹幕': 'Vui lòng nhập nội dung bình luận chỉ định',
  '个月': 'Tháng',
  '已删除': '已删除',
  '已下架': 'Đã gỡ xuống',
  '已上架': 'Đã đăng',
  '已过期': 'Đã hết hạn',
  '未生效': 'Chưa có hiệu lực',
  '中奖率与发送弹幕数量无关': 'Tỷ lệ trúng thưởng không liên quan đến số lượng tin nhắn gửi',
  '中奖率与送礼物数量无关': 'Tỷ lệ trúng thưởng không liên quan đến số lượng quà tặng',
  '送礼越多，中奖率越高': 'Tặng quà càng nhiều, tỷ lệ trúng càng cao',
  '分钟': 'Phút',
  '小时': 'Giờ',
  '人人体育': 'Renren Sports',
  '88直播': '88 Live',
  '看球直播': 'Xem bóng Live',
  '比赛直播': 'Livestream trận đấu',
  '直播时间': 'Thời gian livestream',
  '确认': 'Xác nhận',
  '填写节目名称': 'Nhập tên chương trình',
  '足球': 'Bóng đá',
  '篮球': 'Bóng rổ',
  '网球': 'Quần vợt',
  '乒乓球': 'Bóng bàn',
  '台球': 'Bi-a',
  '羽毛球': 'Cầu lông',
  '其他赛事': 'Môn thể thao khác',
  '娱乐直播': 'Livestream giải trí',
  '主客队/节目名称': 'Đội chủ/đội khách / Tên chương trình',
  '状态': 'Trạng thái',
  '结账成功': 'Thanh toán thành công',
  '注': 'Ghi chú',

  // 聊天室页面
  '请选择举报类型': 'Vui lòng chọn loại báo cáo',
  '提交': 'Gửi',
  '彩色弹幕': 'Bình luận màu',
  '暂无hot词！': 'Chưa có từ khóa hot!',
  '举报': 'Báo cáo',
  '撤回消息': 'Thu hồi tin nhắn',
  '访问网址': 'Truy cập website',
  '是否撤回该聊天消息？': 'Có thu hồi tin nhắn này không?',
  '取消': 'Hủy',
  '确认撤回': 'Xác nhận thu hồi',
  '解除禁言': 'Bỏ cấm chat',
  '禁言': 'Cấm chat',
  '禁言吗？': 'Cấm chat không?',
  '确定要将': 'Xác nhận cấm',
  '您的网络状态不好,请重试': 'Mạng của bạn không ổn định, vui lòng thử lại!',
  '连击': 'gửi liên tiếp',
  '有更多新的消息': 'Có tin nhắn mới',
  '屏蔽消息/特效': 'Chặn tin nhắn / hiệu ứng',
  '屏蔽进场消息': 'Ẩn tin vào',
  '屏蔽礼物消息': 'Ẩn tin quà',
  '屏蔽礼物特效': 'Ẩn hiệu ứng quà',
  '发送': 'Gửi',
  '快来唠两句呗~': 'Vào trò chuyện đi nào~',

  // 直播内容页面
  '粉丝': 'Fan',
  '正在加载...': 'Đang tải...',
  '时': 'Giờ',
  '分': 'Phút',
  '秒': 'Giây',
  '直播间被禁播，正在整顿中...': 'Phòng livestream bị cấm phát, đang trong quá trình xử lý...',
  '点击取消静音': 'Nhấn để bật âm thanh',
  '剧场模式': 'Chế độ rạp',
  '退出剧场': 'Thoát chế độ rạp',
  '全屏模式': 'Chế độ toàn màn hình',
  '退出全屏': 'Thoát toàn màn hình',
  '添加': 'Thêm',
  '节目名称': 'Tên chương trình',
  '送': 'Tặng',

  // 弹幕设置组件
  '弹': 'CHAT',
  '弹幕设置': 'Cài đặt bình luận',
  '弹幕模式': 'Chế độ bình luận',
  '弹幕字号': 'Kích thước chữ bình luận',
  '弹幕透明度': 'Độ trong suốt',
  '无': 'Không',
  '精简': 'Đơn giản',
  '华丽': 'Hiệu ứng đẹp',
  '小': 'Nhỏ',
  '中': 'Vừa',
  '大': 'To',

  // 页面头部组件
  '开播管理': 'Quản lý phát sóng',
  '首页': 'Trang chủ',
  '赛程': 'Lịch thi đấu',
  '退出': 'Thoát',
  '已加入直播平台': 'Đã tham gia nền tảng livestream',
  '天': 'Ngày',
  '我的钱包': 'Ví của tôi',
  '修改头像': 'Đổi ảnh đại diện',
  '退出成功': 'Đăng xuất thành công',
  '修改头像成功': 'Đổi ảnh đại diện thành công',

  '主播休息中': 'Streamer đang nghỉ',
  '周': 'Tuần',
  '时间': 'Thời gian',
  '足球': 'Bóng đá',
  '篮球': 'Bóng rổ',
  '网球': 'Quần vợt',
  '乒乓球': 'Bóng bàn',
  '台球': 'Bi-a',
  '羽毛球': 'Cầu lông',
  '电竞': 'Esports',
  '其他': 'Khác',
  '更多数据': 'Dữ liệu thêm',
  '距离比赛开始还有': 'Còn cách thời gian bắt đầu trận đấu',
  '修改成功': 'Sửa thành công',
  '修改失败': 'Sửa thất bại',
  '弹幕互动': 'Tương tác bình luận',
  '欢迎来到': 'Chào mừng đến với',
  '直播间': 'phòng live',
  '聊天室提倡并监控文明的聊天环境': 'Phòng chat khuyến khích môi trường giao tiếp văn minh',
  '对于违规者账号封禁处理': 'Người vi phạm sẽ bị khóa tài khoản',
  '威胁辱骂': 'Đe dọa, xúc phạm',
  '色情骚扰': 'Quấy rối tình dục',
  '垃圾广告': 'Quảng cáo rác',
  '暴力血腥': 'Bạo lực, máu me',
  '违法行为': 'Hành vi vi phạm pháp luật',
  '其他': 'Khác',
  '网络连接异常，正在重连直播间': 'Kết nối mạng bất thường, đang kết nối lại phòng livestream',
  '网络连接失败，请检查您的网络！': 'Kết nối mạng thất bại, vui lòng kiểm tra lại mạng!',
  '连接成功': 'Kết nối thành công',
  '举报成功': 'Báo cáo thành công',
  '撤回成功': 'Thu hồi thành công',
  '禁言成功': 'Cấm chat thành công',
  '主播不可参与投注趣猜题目': 'Streamer không được tham gia đặt cược dự đoán',
  '每场趣猜题目结束后，会从趣猜用户总奖池中扣除': 'Sau mỗi câu hỏi dự đoán kết thúc, sẽ trích một phần từ tổng quỹ thưởng của người chơi.',
  '金额作为给出题主播奖励': 'làm phần thưởng cho streamer tạo câu hỏi',
  '若出现不可抗力导致题目关闭，均被判为流局，所有用户的投注金额将全额返还': 'Nếu có sự cố bất khả kháng khiến câu hỏi bị đóng, sẽ được xử hòa, toàn bộ tiền cược sẽ được hoàn trả.',
  '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还': 'Nếu streamer quên kết toán, sau 12 giờ hệ thống sẽ tự động xử hòa và hoàn trả toàn bộ tiền cược.',
  '如果在结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局': 'Nếu khi kết toán có một hoặc hai lựa chọn không có ai đặt cược, hoặc tất cả lựa chọn đều sai, câu hỏi sẽ bị xử hòa.',
  '若主播结账错误，用户或主播请第一时间联系客服申诉并提供相关截图。官方会根据多方渠道进行核实': 'Nếu streamer kết toán sai, người dùng hoặc streamer cần liên hệ CSKH ngay và cung cấp ảnh chụp màn hình. Nền tảng sẽ xác minh.',
  '确认情况属实，会进行重审或补发奖励，并对主播进行处罚': 'Nếu xác nhận đúng, sẽ xét lại hoặc phát lại thưởng và xử phạt streamer.',
  '趣猜是指主播发起一道竞答题目并设置题目和选项，观众可以在选项之间竞答，当主播确认了竞答结果后，胜利的一方将会分摊失败的一方的投注金额（如下图）': '“Dự đoán vui” là tính năng streamer tạo câu hỏi và lựa chọn, người xem đặt cược giữa các lựa chọn. Sau khi có kết quả, bên thắng sẽ chia tiền cược của bên thua.',
  '点击你要支持的选项，选择或输入投注金额后点击提交即可': 'Nhấn vào lựa chọn bạn ủng hộ, nhập số tiền cược rồi gửi.',
  '金额作为给出题主播奖励': 'làm phần thưởng cho streamer tạo câu hỏi.',
  '若奖金金额分配后出现小数，小数后金额向下取整（如三个人分100金币，每个33.3，向下取整后每人发放33金币）': 'Nếu chia thưởng có số lẻ, sẽ làm tròn xuống (ví dụ 3 người chia 100 xu → mỗi người nhận 33 xu).',
  '趣猜每次单场单笔投注金额限制，金币趣猜最小为': 'Mỗi lần đặt cược có giới hạn, tối thiểu là (…xu)',
  '主播对趣猜结账后，可进入【趣猜记录】查看，趣猜奖励可能存在延迟到账，若长时间未到账请联系客服咨询': 'Sau khi streamer kết toán, có thể xem trong “Lịch sử dự đoán”, thưởng có thể đến chậm, nếu lâu chưa nhận vui lòng liên hệ CSKH.',
  '若主播忘记结账，题目将在12小时后自动判为流局，所有用户的投注金额将全额返还，主播不可参与趣猜': 'Nếu streamer quên kết toán, sau 12 giờ sẽ tự xử hòa và hoàn tiền, streamer không được tham gia.',
  '特殊情况：如果在趣猜结账时，有一个或两个选项没有任何人投注，或所有选项都非正确选项，则本题目会判为流局': 'Trường hợp đặc biệt: nếu không có ai đặt cược ở một hoặc hai lựa chọn, hoặc tất cả sai → xử hòa.',
  '趣猜系统旨在提升用户观看直播体验，仅供娱乐交流使用': 'Hệ thống dự đoán nhằm tăng trải nghiệm xem livestream, chỉ mang tính giải trí.',
  '请通过官方渠道获取投注金额，因非正当渠道获取而无法参与趣猜的，用户需自行承担不利后果': 'Vui lòng sử dụng kênh chính thức để nạp tiền, nếu dùng nguồn không hợp lệ sẽ không được tham gia.',
  '任何影响互动公平性的操作，官方有权取消用户参与主播趣猜资格，并对违规金额进行收回': 'Mọi hành vi ảnh hưởng tính công bằng, nền tảng có quyền cấm tham gia và thu hồi tiền.',
  '若有发现违规趣猜，欢迎用户举报': 'Nếu phát hiện vi phạm, người dùng có thể báo cáo.',
  '全平台的粉丝徽章名称不能重复（包括审核中的名称）': 'Tên huy hiệu fan toàn nền tảng không được trùng (kể cả đang xét duyệt)',
  '粉丝徽章名称仅支持中文、数字或英文（大小写）': 'Tên huy hiệu chỉ hỗ trợ chữ Trung, số hoặc tiếng Anh',
  '名称至少为1个字，纯中文不超2个字，只有1个中文时不能超过3个字；不包含中文则不能超过4个字': 'Tên tối thiểu 1 ký tự, nếu toàn chữ Trung tối đa 2 ký tự; nếu 1 chữ Trung thì tối đa 3 ký tự; nếu không có chữ Trung thì tối đa 4 ký tự',
  '粉丝牌名称审核通过后才能生效，不可使用涉政、涉黄、涉暴等敏感词汇，不可使用网络平台专属词汇， 不可使用带有广告意图的词汇；尽量与主播历史常用昵称相关': 'Tên huy hiệu phải được duyệt mới có hiệu lực, không được chứa nội dung nhạy cảm, chính trị, bạo lực, quảng cáo…',
  '每30天，主播最多可以修改1次粉丝牌名称': 'Mỗi 30 ngày streamer chỉ được đổi tên huy hiệu 1 lần',
  '请选择': 'Vui lòng chọn',
  '抽奖是本平台提供的直播间互动玩法，由平台提供奖品，用户通过发弹幕或送礼物参与抽奖': 'Quay thưởng là tính năng tương tác livestream do nền tảng cung cấp, người dùng tham gia bằng chat hoặc tặng quà.',
  '金币奖品抽奖结束后查看金币收益记录，兑换劵奖品抽奖结束后查看兑换券记录': 'Sau khi quay thưởng phần thưởng bằng xu kết thúc, hãy xem trong lịch sử thu nhập xu; sau khi quay thưởng phần thưởng bằng phiếu đổi thưởng kết thúc, hãy xem trong lịch sử phiếu đổi thưởng.',
  '抽奖活动由主播发起，并从本平台限定的既有参与方式进行选择。参与抽奖互动功能过程中，用户有权在规定时间内参与抽奖活动': 'Chương trình quay thưởng do streamer khởi xướng và phải lựa chọn từ các phương thức tham gia do nền tảng quy định sẵn. Trong quá trình tham gia tính năng tương tác quay thưởng, người dùng có quyền tham gia chương trình trong thời gian quy định.',
  '除本平台限定的既有方式外，主播不得自定义中奖规则和任何领奖附加条件，此类附加规则和条件一律无效': 'Ngoài các phương thức đã được nền tảng quy định sẵn, streamer không được tự đặt quy tắc trúng thưởng hoặc bất kỳ điều kiện nhận thưởng bổ sung nào; mọi quy tắc và điều kiện như vậy đều không có hiệu lực.',
  '发起的抽奖活动，在抽奖结束后自动陆续发放奖励。如有奖励长时间未到账情况，请联系客服咨询': 'Các chương trình quay thưởng sau khi được tạo sẽ tự động phát thưởng lần lượt sau khi kết thúc. Nếu phần thưởng chưa được nhận trong thời gian dài, vui lòng liên hệ chăm sóc khách hàng để được hỗ trợ.',
  '使用本平台抽奖互动功能举办的抽奖活动，所生成的抽奖结果均有效，且不可撤销、删除、更改': 'Các chương trình quay thưởng được tổ chức bằng tính năng tương tác của nền tảng này, mọi kết quả quay thưởng được tạo ra đều hợp lệ và không thể hủy, xóa hoặc thay đổi.',
  '任何影响互动公平性的操作，官方有权取消用户参与主播抽奖资格，并对违规金额和奖品进行收回': 'Bất kỳ hành vi nào ảnh hưởng đến tính công bằng của hoạt động tương tác, nền tảng có quyền hủy quyền tham gia quay thưởng của người dùng và thu hồi số tiền cũng như phần thưởng vi phạm.',
  '本活动最终解释权归平台所有。若有发现违规抽奖，欢迎用户举报': 'Quyền giải thích cuối cùng của hoạt động này thuộc về nền tảng. Nếu phát hiện hành vi quay thưởng vi phạm, người dùng được hoan nghênh báo cáo.',
  '奖品类型': 'Loại phần thưởng',
  '抽奖金额': 'Số tiền quay thưởng',
  '选择奖品': 'Chọn phần thưởng',
  '张': '(Tờ / vé)',
  '抽奖方式': 'Hình thức quay thưởng',
  '指定弹幕': 'Bình luận chỉ định',
  '指定礼物': 'Quà tặng chỉ định',
  '礼物数量': 'Số lượng quà',
  '抽取规则': 'Quy tắc chọn',
  '面向用户': 'Đối tượng người dùng',
  '等级要求': 'Yêu cầu cấp độ',
  '注': 'Ghi chú',
  '主播不可参与抽奖': 'Streamer không được tham gia quay thưởng',
  '抽奖活动是人人体育平台提供的直播间互动玩法。由平台提供奖品，粉丝通过发弹幕或送礼物参与抽奖': 'Quay thưởng là tính năng tương tác do nền tảng cung cấp, fan tham gia qua chat hoặc tặng quà',
  '平台每月提供定量的金币和兑换券，未消耗的奖品次月会自动清空': 'Mỗi tháng nền tảng cấp số lượng xu và phiếu nhất định, phần chưa dùng sẽ bị xóa vào tháng sau',
  '兑换券自发放给用户之日起，有效期': 'Phiếu đổi thưởng có thời hạn kể từ ngày cấp phát:',
  '月': 'tháng',
  '日': 'ngày',
  '奖品信息': 'Thông tin giải thưởng',
  '参与时间': 'Thời gian tham gia',
  '最大为': 'Tối đa',
  '注': 'Ghi chú',
  // 直播间榜单
  '主播未开通粉丝团～': 'Streamer chưa mở fan club~',
  '送礼上榜提示': 'Tặng quà để lên BXH {wordDeal}~',
  '送主播礼物，上{rank}榜~': 'Tặng quà lên top {rank}~',
  '按本周粉丝亲密值上升排行': 'Xếp hạng theo độ thân mật tuần',
  '周贡榜': 'BXH tuần',
  '总贡榜': 'BXH tổng',
  '粉丝榜': 'BXH fan',
  '周贡': 'Cống tuần',
  '总贡': 'Tổng cống',
  '粉丝': 'Fan',
  '进入直播间': 'Vào phòng live',
  '弹幕': 'Bình luận',
  '精简': 'Làm gọn',
  '华丽': 'Hiệu ứng',
  '弹幕小': 'Nhỏ',
  '弹幕中': 'Vừa',
  '弹幕大': 'To',
}
